import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { matchPath } from 'react-router-dom'
import { UserAlert } from '../proto/generated/nexus'
import ROUTES from '../assets/routes'
import { selectPrimarySecurity } from '../selectors/home'
import { getUserAlertKey, getUserAlertUnderlyingSecurity } from '../util/alerts'
import { openChartInNewWindow } from '../util/common'
import useSetPrimarySecurity from './useSetPrimarySecurity'

export default function useAlertItemClick() {
    const setPrimarySecurity = useSetPrimarySecurity()
    const primaryKey = useSelector(selectPrimarySecurity).key

    return useCallback(
        (alert: UserAlert) => {
            const [securityList, expression] = getUserAlertUnderlyingSecurity(alert)
            if (!securityList.length && !expression) return

            const alertKey = getUserAlertKey(alert)
            if (!alertKey) return

            if (matchPath(ROUTES.chart, window.location.pathname)) {
                if (alertKey === primaryKey) return
                setPrimarySecurity(alertKey, securityList, !!expression.length)
                return
            }

            openChartInNewWindow(alertKey)
        },
        [setPrimarySecurity, primaryKey]
    )
}
